import type { CountryCode } from '@module/apis/client-side/live/type';
import type { LangCode } from '@module/types/centrifuge/public-message';

const COUNTRY_NAME_MAP: Record<CountryCode, { ko: string; ja: string; zh: string; en: string }> = {
  kr: { ko: '한국', ja: '韓国', zh: '韓国', en: 'korea' },
  cn: { ko: '중국', ja: '中国', zh: '中国', en: 'china' },
  jp: { ko: '일본', ja: '日本', zh: '日本', en: 'japan' },
  us: { ko: '미국', ja: 'アメリカ', zh: '美国', en: 'usa' },
};

const LANG_TO_COUNTRY_MAP: Record<LangCode, CountryCode> = {
  ko: 'kr',
  ja: 'jp',
  zh: 'cn',
  en: 'us',
};

export const getCountryCodeFromLang = (lang: LangCode) => {
  return LANG_TO_COUNTRY_MAP[lang] ?? lang;
};

export const getCountryNames = (locales: CountryCode[], lang: LangCode) => {
  const filteredNames = locales
    .map((locale) => COUNTRY_NAME_MAP[locale][lang])
    .filter(Boolean)
    .join(', ');

  return filteredNames ? `(${filteredNames})` : '';
};
